import { render, staticRenderFns } from "./FileInfoCard.vue?vue&type=template&id=42f910fd&scoped=true"
import script from "./FileInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FileInfoCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FileInfoCard.vue?vue&type=style&index=0&id=42f910fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f910fd",
  null
  
)

export default component.exports